import { render } from "./TextBox.vue?vue&type=template&id=278e7992"
import script from "./TextBox.vue?vue&type=script&lang=js"
export * from "./TextBox.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TextBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "278e7992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('278e7992', __exports__)) {
    api.reload('278e7992', __exports__)
  }
  
  module.hot.accept("./TextBox.vue?vue&type=template&id=278e7992", () => {
    api.rerender('278e7992', render)
  })

}


export default __exports__